import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import { Container } from "reactstrap";
import AccountNav from "../../components/account/AccountNav";
import { fetchApiAccess } from "../../store/actions/apiAccessAction";
import ApiManagement from "./ApiManagement";
import Billing from "./Billing";
import MyDetails from "./MyDetails";
import Plan from "./Plan";
import Security from "./Security";

/*
    The account area shell: sign-in guard, navigation, and the five pages.

    Registered as a NON-exact route (see routes/index.js), so this component
    stays mounted while the customer moves between tabs. That matters for one
    thing in particular — the API access status pill in the navigation. It is
    fetched once here rather than by each page, so the badge is already
    correct when you arrive from anywhere, and moving between tabs does not
    re-request it.

    Everything else each page fetches for itself, following the existing
    Repository -> thunk -> component path rather than threading a shared blob
    of state down through props.
*/
const AccountLayout = () => {
  const dispatch = useDispatch();
  const { uid } = useSelector((state) => state.authUser);

  useEffect(() => {
    if (uid) {
      dispatch(fetchApiAccess());
    }
  }, [dispatch, uid]);

  if (!uid) {
    return <Redirect to="/auth/signin" />;
  }

  return (
    <div className="w-100 py-5 px-wide px-lg-narrow account">
      <Container>
        <div className="account__layout">
          <AccountNav />
          <main className="account__content">
            <Switch>
              <Route exact path="/account" component={MyDetails} />
              <Route exact path="/account/security" component={Security} />
              <Route exact path="/account/billing" component={Billing} />
              <Route exact path="/account/plan" component={Plan} />
              <Route exact path="/account/api" component={ApiManagement} />
              {/* An unknown /account/* path is not a 404 for the whole app. */}
              <Redirect to="/account" />
            </Switch>
          </main>
        </div>
      </Container>
    </div>
  );
};

export default AccountLayout;
